import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-size-x-small mt-4 font-italic" }, " This may take a moment, please be patient! ", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressDialog',
  props: {
  title: {
    type: String,
    required: false,
    default: ''
  },
  shouldShowProgressDialog: {
    type: Boolean,
    required: false,
    default: false
  },
  currentStepMessage: {
    type: String,
    required: false,
    default: ''
  },
  currentPerc: {
    type: Number,
    required: false,
    default: 0
  }
},
  setup(__props) {

const props = __props

/* global defineProps */



return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": props.shouldShowProgressDialog,
    width: 500,
    persistent: "",
    scrollable: "",
    transition: "fade"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "dialog-box",
        width: 500
      }, {
        default: _withCtx(() => [
          (__props.title)
            ? (_openBlock(), _createBlock(_component_v_card_title, {
                key: 0,
                class: "text-center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.title), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_text, { class: "px-8 pb-6 pt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createVNode(_Transition, {
                    name: "slide-fade",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("div", {
                        class: "font-size-large text-center mb-6",
                        key: props.currentStepMessage
                      }, _toDisplayString(props.currentStepMessage), 1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_progress_linear, {
                    "model-value": props.currentPerc,
                    stream: "",
                    "buffer-value": "0",
                    color: "info",
                    height: "25"
                  }, {
                    default: _withCtx(({ value }) => [
                      _createElementVNode("strong", null, _toDisplayString(Math.ceil(value)) + "%", 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})